<template>
  <div class="search">
    <SearchComponent :contentList="contentList" ></SearchComponent>
  </div>
</template>

<script>
import SearchComponent from '../components/SearchComponent';
import { searchContentParser } from '../data/userData';

export default {
  name: 'Search',
  components: {
    SearchComponent,
  },
  props: {
    userDoc2: Object,
    managerDoc2: Object,
  },
  computed: {
    contentList() {
      return searchContentParser(
        this.$route.params.content,
        this.userDoc2,
        this.managerDoc2,
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
